// language=GraphQL
export const ALL_REDIRECTS_QUERY = `query Query($withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {
  redirects: redirects {
    id
    fromType
    fromUrl
    fromPage @include(if: $withFromPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withFromPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withFromPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {
        id
        type
        block @include(if: $withFromPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    fromTravel @include(if: $withFromTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withFromTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withFromTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withFromTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withFromTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withFromTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withFromTravelTenantSettings) {
        id
        tenant @include(if: $withFromTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withFromTravelHighlights) {
        id
        text
      }
      partners @include(if: $withFromTravelPartners) {
        id
        name
        url
        logo @include(if: $withFromTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withFromTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withFromTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withFromTravelTeams) {
        id
        name
        members @include(if: $withFromTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withFromTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withFromTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withFromTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withFromTravelTestimonials) {
        id
        contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withFromTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withFromTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withFromTravelGallery) {
        id
        images @include(if: $withFromTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withFromTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withFromTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withFromTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withFromTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withFromTravelItinerary) {
        id
        items @include(if: $withFromTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withFromTravelPricing) {
        id
        ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withFromTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withFromTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withFromTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withFromTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withFromTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withFromTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
    toType
    toUrl
    toPage @include(if: $withToPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withToPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withToPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {
        id
        type
        block @include(if: $withToPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    toTravel @include(if: $withToTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withToTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withToTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withToTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withToTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withToTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withToTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withToTravelTenantSettings) {
        id
        tenant @include(if: $withToTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withToTravelHighlights) {
        id
        text
      }
      partners @include(if: $withToTravelPartners) {
        id
        name
        url
        logo @include(if: $withToTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withToTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withToTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withToTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withToTravelTeams) {
        id
        name
        members @include(if: $withToTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withToTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withToTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withToTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withToTravelTestimonials) {
        id
        contentBlock @include(if: $withToTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withToTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withToTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withToTravelGallery) {
        id
        images @include(if: $withToTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withToTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withToTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withToTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withToTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withToTravelItinerary) {
        id
        items @include(if: $withToTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withToTravelPricing) {
        id
        ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withToTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withToTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withToTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withToTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withToTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withToTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withToTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`

// language=GraphQL
export const SINGLE_REDIRECT_QUERY = `query Query($id: ID!, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {
  redirect: redirect(id: $id) {
    id
    fromType
    fromUrl
    fromPage @include(if: $withFromPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withFromPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withFromPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {
        id
        type
        block @include(if: $withFromPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    fromTravel @include(if: $withFromTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withFromTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withFromTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withFromTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withFromTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withFromTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withFromTravelTenantSettings) {
        id
        tenant @include(if: $withFromTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withFromTravelHighlights) {
        id
        text
      }
      partners @include(if: $withFromTravelPartners) {
        id
        name
        url
        logo @include(if: $withFromTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withFromTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withFromTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withFromTravelTeams) {
        id
        name
        members @include(if: $withFromTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withFromTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withFromTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withFromTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withFromTravelTestimonials) {
        id
        contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withFromTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withFromTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withFromTravelGallery) {
        id
        images @include(if: $withFromTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withFromTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withFromTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withFromTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withFromTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withFromTravelItinerary) {
        id
        items @include(if: $withFromTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withFromTravelPricing) {
        id
        ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withFromTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withFromTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withFromTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withFromTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withFromTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withFromTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
    toType
    toUrl
    toPage @include(if: $withToPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withToPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withToPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {
        id
        type
        block @include(if: $withToPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    toTravel @include(if: $withToTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withToTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withToTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withToTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withToTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withToTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withToTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withToTravelTenantSettings) {
        id
        tenant @include(if: $withToTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withToTravelHighlights) {
        id
        text
      }
      partners @include(if: $withToTravelPartners) {
        id
        name
        url
        logo @include(if: $withToTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withToTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withToTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withToTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withToTravelTeams) {
        id
        name
        members @include(if: $withToTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withToTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withToTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withToTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withToTravelTestimonials) {
        id
        contentBlock @include(if: $withToTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withToTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withToTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withToTravelGallery) {
        id
        images @include(if: $withToTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withToTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withToTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withToTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withToTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withToTravelItinerary) {
        id
        items @include(if: $withToTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withToTravelPricing) {
        id
        ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withToTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withToTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withToTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withToTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withToTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withToTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withToTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`

// language=GraphQL
export const CREATE_REDIRECT_MUTATION = `
  mutation Mutation($input: CreateRedirectInput, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {
    redirect: createRedirect(input: $input) {
      id
      fromType
      fromUrl
      fromPage @include(if: $withFromPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withFromPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withFromPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {
          id
          type
          block @include(if: $withFromPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      fromTravel @include(if: $withFromTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withFromTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withFromTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withFromTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withFromTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withFromTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withFromTravelTenantSettings) {
          id
          tenant @include(if: $withFromTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withFromTravelHighlights) {
          id
          text
        }
        partners @include(if: $withFromTravelPartners) {
          id
          name
          url
          logo @include(if: $withFromTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withFromTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withFromTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withFromTravelTeams) {
          id
          name
          members @include(if: $withFromTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withFromTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withFromTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withFromTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withFromTravelTestimonials) {
          id
          contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withFromTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withFromTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withFromTravelGallery) {
          id
          images @include(if: $withFromTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withFromTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withFromTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withFromTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withFromTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withFromTravelItinerary) {
          id
          items @include(if: $withFromTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withFromTravelPricing) {
          id
          ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withFromTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withFromTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withFromTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withFromTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withFromTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withFromTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
      toType
      toUrl
      toPage @include(if: $withToPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withToPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withToPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {
          id
          type
          block @include(if: $withToPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      toTravel @include(if: $withToTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withToTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withToTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withToTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withToTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withToTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withToTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withToTravelTenantSettings) {
          id
          tenant @include(if: $withToTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withToTravelHighlights) {
          id
          text
        }
        partners @include(if: $withToTravelPartners) {
          id
          name
          url
          logo @include(if: $withToTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withToTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withToTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withToTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withToTravelTeams) {
          id
          name
          members @include(if: $withToTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withToTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withToTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withToTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withToTravelTestimonials) {
          id
          contentBlock @include(if: $withToTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withToTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withToTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withToTravelGallery) {
          id
          images @include(if: $withToTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withToTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withToTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withToTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withToTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withToTravelItinerary) {
          id
          items @include(if: $withToTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withToTravelPricing) {
          id
          ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withToTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withToTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withToTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withToTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withToTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withToTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withToTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
    }
  }`

// language=GraphQL
export const UPDATE_REDIRECT_MUTATION = `
  mutation Mutation($input: UpdateRedirectInput, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {
    redirect: updateRedirect(input: $input) {
      id
      fromType
      fromUrl
      fromPage @include(if: $withFromPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withFromPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withFromPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {
          id
          type
          block @include(if: $withFromPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      fromTravel @include(if: $withFromTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withFromTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withFromTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withFromTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withFromTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withFromTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withFromTravelTenantSettings) {
          id
          tenant @include(if: $withFromTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withFromTravelHighlights) {
          id
          text
        }
        partners @include(if: $withFromTravelPartners) {
          id
          name
          url
          logo @include(if: $withFromTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withFromTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withFromTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withFromTravelTeams) {
          id
          name
          members @include(if: $withFromTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withFromTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withFromTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withFromTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withFromTravelTestimonials) {
          id
          contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withFromTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withFromTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withFromTravelGallery) {
          id
          images @include(if: $withFromTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withFromTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withFromTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withFromTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withFromTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withFromTravelItinerary) {
          id
          items @include(if: $withFromTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withFromTravelPricing) {
          id
          ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withFromTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withFromTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withFromTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withFromTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withFromTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withFromTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
      toType
      toUrl
      toPage @include(if: $withToPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withToPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withToPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {
          id
          type
          block @include(if: $withToPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      toTravel @include(if: $withToTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withToTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withToTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withToTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withToTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withToTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withToTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withToTravelTenantSettings) {
          id
          tenant @include(if: $withToTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withToTravelHighlights) {
          id
          text
        }
        partners @include(if: $withToTravelPartners) {
          id
          name
          url
          logo @include(if: $withToTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withToTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withToTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withToTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withToTravelTeams) {
          id
          name
          members @include(if: $withToTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withToTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withToTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withToTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withToTravelTestimonials) {
          id
          contentBlock @include(if: $withToTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withToTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withToTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withToTravelGallery) {
          id
          images @include(if: $withToTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withToTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withToTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withToTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withToTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withToTravelItinerary) {
          id
          items @include(if: $withToTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withToTravelPricing) {
          id
          ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withToTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withToTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withToTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withToTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withToTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withToTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withToTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
    }
  }`

// language=GraphQL
export const DELETE_REDIRECT_MUTATION = `
  mutation Mutation($input: DeleteRedirectInput) {
    deleteRedirect(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_REDIRECT_MUTATION = `
  mutation Mutation($input: DeleteRedirectInput) {
    forceDeleteRedirect(input: $input) {
      success
    }
  }`
// language=GraphQL
export const REDIRECTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: redirectDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
